import { combineReducers } from '@reduxjs/toolkit'

import { reducer as squarePay } from './square'

export default combineReducers({
  squarePay,
})
